import { render, staticRenderFns } from "./HelpSidebar.vue?vue&type=template&id=20aa635a&"
import script from "./HelpSidebar.vue?vue&type=script&lang=js&"
export * from "./HelpSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports